module.exports = __webpack_public_path__ + "static/media/statementbanner.5d946451.jpg";